var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clearfix" }, [
    _c(
      "div",
      {
        ref: "cpCommentSubmitModal",
        staticClass: "reveal cp-comment-submit-modal",
        attrs: { id: "cpCommentSubmitModal", "data-reveal": "" },
      },
      [
        _vm.designDocsChanged || !_vm.canDocsAbleToSubmit
          ? _c("div", { staticClass: "notify-msg" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenantProjects.submission.designDocChanged")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("label", { staticClass: "cp-review-title" }, [
          _vm._v(_vm._s(_vm.$t("tenantProjects.submission.batchStatus"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tender-confirm clearfix",
            attrs: { id: "design-comment-status" },
          },
          [
            _c("div", { staticClass: "radio-item" }, [
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "radioClass",
                attrs: {
                  id: "comment-disapprove",
                  name: "type",
                  type: "radio",
                },
                domProps: {
                  checked:
                    _vm.designComment.comment ===
                    _vm.DesignBatchStatus.DISAPPROVE,
                },
                on: {
                  click: function (event) {
                    return _vm.updateCommentRadio(
                      _vm.DesignBatchStatus.DISAPPROVE
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "radio-label",
                  attrs: { for: "comment-disapprove" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.actionTexts.DISAPPROVE) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "radio-item" }, [
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "radioClass",
                attrs: {
                  id: "proceed-no-follow-up",
                  name: "type",
                  type: "radio",
                },
                domProps: {
                  checked:
                    _vm.designComment.comment ===
                    _vm.DesignBatchStatus.PROCEED_NO_FOLLOW_UP,
                },
                on: {
                  click: function (event) {
                    return _vm.updateCommentRadio(
                      _vm.DesignBatchStatus.PROCEED_NO_FOLLOW_UP
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "radio-label",
                  attrs: { for: "proceed-no-follow-up" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.actionTexts.PROCEED_NO_FOLLOW_UP) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "radio-item" }, [
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "radioClass",
                attrs: {
                  id: "proceed-cp-follow-up",
                  name: "type",
                  type: "radio",
                },
                domProps: {
                  checked:
                    _vm.designComment.comment ===
                    _vm.DesignBatchStatus.PROCEED_CP_FOLLOW_UP,
                },
                on: {
                  click: function (event) {
                    return _vm.updateCommentRadio(
                      _vm.DesignBatchStatus.PROCEED_CP_FOLLOW_UP
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "radio-label",
                  attrs: { for: "proceed-cp-follow-up" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.actionTexts.PROCEED_CP_FOLLOW_UP) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row align-right nav_btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              attrs: { id: "confirm_no", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.rollbackDesignCommentAndCloseModal()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { id: "confirm_ok", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.ok")))]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }